import { authConstants } from '../_constants';
import { initialState } from '../_helpers';

export function authentication(state=initialState.user, action) {
    switch (action.type) {
        case authConstants.LOGIN_REQUEST:
          return {
            loggingIn: true,
            user: action.user
          };
        case authConstants.LOGIN_SUCCESS:
            return {
            loggedIn: true,
            user: action.user
          };
        case authConstants.LOGIN_FAILURE:
          return Object.assign({}, state, {loggingIn: false, errorMessage: action.error.error_description});
        case authConstants.LOGOUT:
          return {};
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js